import { useEffect } from 'react';
import styled, { useTheme } from 'styled-components';
import useContactController from '../../../1_application/intro/contactController';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXLowButton from '../../core/components/buttons/lxLowButton';
import { device, useMedia } from '../../core/designSystem/device';
import { LXLabelInput } from '../../core/texts/lxInput';
import { LXbody } from '../../core/texts/lxText';

const SendBox = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  @media ${device.tabletAndBelow} {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

const NameEmailBox = styled.div`
  display: flex;
  flex-direction: row;
  @media ${device.tabletAndBelow} {
    flex-direction: column;
  }
`;

const RelativeBox = styled.div`
  position: relative;
`;

interface ContactFormProps {}
const ContactForm = (props: ContactFormProps) => {
  const { isDesktop, isTabletAndBelow } = useMedia();
  const theme = useTheme();
  const c = useContactController();

  const CountText = () => {
    return (
      <LXbody
        style={{ position: 'absolute', right: 16, bottom: 8 }}
        color={
          c.message.length !== 0 && c.message.length < 10
            ? theme.colors.error
            : theme.colors.caption
        }
      >
        {c.message.length}/1000
      </LXbody>
    );
  };

  useEffect(() => {
    if (c.loading) {
      document.body.style.cursor = 'wait';
    } else {
      document.body.style.cursor = 'default';
    }
  }, [c.loading]);

  return (
    <Column width={isDesktop ? '688px' : '100%'}>
      <SizedBox height={isDesktop ? 0 : 40} />
      <RelativeBox>
        <CountText />
        <NameEmailBox>
          <LXLabelInput
            value={c.name}
            onChange={c.setName}
            label={theme.intro.name}
            width={isTabletAndBelow ? undefined : 336}
            placeholder={theme.intro.enterYourName}
          ></LXLabelInput>
          <SizedBox height={16} width={16} />
          <LXLabelInput
            value={c.email}
            onChange={c.setEmail}
            label={theme.intro.email}
            width={isTabletAndBelow ? undefined : 336}
            placeholder={theme.intro.enterYourEmail}
          ></LXLabelInput>
        </NameEmailBox>
        <SizedBox height={24} width={16} />
        <LXLabelInput
          value={c.phone}
          onChange={c.setPhone}
          label={theme.intro.phone}
          placeholder={theme.intro.enterYourPhoneNumber}
        ></LXLabelInput>
        <SizedBox height={24} width={16} />
        <LXLabelInput
          value={c.message}
          onChange={c.setMessage}
          isMultiline={true}
          height={160}
          label={theme.intro.message}
          placeholder={theme.intro.enterYourMessage}
        ></LXLabelInput>
      </RelativeBox>
      <SizedBox height={isDesktop ? 24 : 40} />
      <SendBox>
        <Row flexWrap="wrap">
          <LXbody color={theme.colors.caption}>
            {theme.intro.bySendingAMessageYouAgreeToOur}
          </LXbody>
          &nbsp;
          <button
            disabled
            onClick={() => {}}
            style={{
              border: 'none',
              backgroundColor: 'transparent',
            }}
          >
            <LXbody>{theme.intro.termsAndConditions}</LXbody>
          </button>
          &nbsp;
          <LXbody color={theme.colors.caption}>{theme.intro.and}</LXbody>
          &nbsp;
          <button
            disabled
            onClick={() => {}}
            style={{
              border: 'none',
              backgroundColor: 'transparent',
            }}
          >
            <LXbody>{theme.intro.privacyPolicy}</LXbody>
          </button>
        </Row>
        <SizedBox width={16} flexGrow={isDesktop ? 1 : 0} />
        <LXLowButton
          disabled={
            c.loading ||
            c.email === '' ||
            c.name === '' ||
            c.phone === '' ||
            c.message === '' ||
            c.message.length < 10
          }
          disabledColor={theme.colors.disabled}
          width={isDesktop ? 'undefined' : '100%'}
          onClick={c.onSendMessage}
          fontSize={'13px'}
        >
          {theme.intro.sendMessage}
        </LXLowButton>
      </SendBox>
      <SizedBox height={isDesktop ? 100 : 80} />
    </Column>
  );
};

export default ContactForm;
